"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDollarAmount = void 0;
const { locale } = Intl.NumberFormat().resolvedOptions();
/**
 * Formats a dollar amount - adding a dollar sign,
 * ensuring there are exactly 2 decimal places,
 * and adding commas
 * https://stackoverflow.com/questions/5340530/how-to-format-a-dollar
 * @param amount an amount of money as a number
 * @returns a formatted string
 */
function formatDollarAmount(amount, hidePenniesForEvenDollars) {
    let str = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: hidePenniesForEvenDollars && amount === Math.floor(amount) ? 0 : 2,
    }).format(amount);
    return str;
}
exports.formatDollarAmount = formatDollarAmount;
